module.exports = __webpack_public_path__ + "img/complete_btn.bea3e430.png";